module.exports = __webpack_public_path__ + "static/green_dragon_wyrmling-417d484ca422438b95fd38bbf8b1b707.png";